/* eslint-disable eqeqeq */
import React, { useEffect, useState, useRef } from "react";
import { GoogleMap, Marker, InfoWindow } from '@react-google-maps/api';

import styled from "styled-components";
import MapMarker from "assets/icons/map-marker.svg";
import SimilarMarkerIcon from "assets/icons/similar-marker.svg";
import useGoogleMapsLoader from "hooks/useGoogleMapsLoader";

const InfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 22px 24px;
`;

const InfoHeading = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;

    img {
        width: 10px;
        height: 13px;
        object-position: center;
        object-fit: cover;
    }
`;

const InfoId = styled.h4`
    color: #111827;
    font-weight: 500;
    font-size: 14px;
`;

const InfoTitle = styled.h3`
    color: #006bb4;
    font-size: 16px;
    font-weight: 600;
`;

const InfoDetails = styled.p`
    color: #6b7280;
    font-weight: 400;
    font-size: 12px;
`;

const InfoTags = styled.div`
    display: flex;
    gap: 8px;
    border-radius: 4px;
    margin-top: 10px;
`;

const InfoTag = styled.div`
    background-color: ${(props) => (props.type === "category" ? "#DBEAFE" : "#FEF3C7")};
    color: ${(props) => (props.type === "category" ? "#1E40AF;" : "#92400E")};
    font-weight: 500;
    font-size: 12px;
    padding: 2px 12px;
    text-transform: capitalize;
    border-radius: 4px;
`;

const GoogleMapComponent =
    ({
        setMapLocationData,
        isOpen,
        lat,
        lang,
        zoom,
        isMarkerShown,
        multipleMarkers,
        similarLocations,
        readOnly,
        isLocationSelectedFromSearch,
        setIsLocationSelectedFromSearch,
    }) => {
        const [currentPosition, setCurrentPosition] = useState({
            lat: 0,
            lang: 0,
        });
        const [activeMarker, setActiveMarker] = useState(null);
        const { isLoaded } = useGoogleMapsLoader();
        const mapRef = useRef(null);

        const onLoad = React.useCallback(function callback(map) {
            mapRef.current = map
        }, [])

        useEffect(() => {
            if (isOpen && !readOnly && !lat && !lang) {
                navigator.geolocation.getCurrentPosition((position) => {
                    setCurrentPosition({
                        lat: position.coords.latitude,
                        lang: position.coords.longitude,
                    });
                });
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [isOpen]);

        const onMarkerDragEnd = (coord) => {
            setIsLocationSelectedFromSearch(false);
            if (!readOnly) {
                const { latLng } = coord;
                const lat = latLng.lat();
                const lng = latLng.lng();
                setCurrentPosition({ lat, lang: lng });
                getReverseGeocodingData(lat, lng);
            }
        };

        useEffect(() => {
            if (isOpen && lat !== 0 && lang !== 0 && mapRef.current) {
                setCurrentPosition({ lat: +lat, lang: +lang });
                getReverseGeocodingData(lat, lang);
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [lat, lang, isOpen, mapRef.current]);

        const getReverseGeocodingData = (lat, lng) => {
            const latlng = new window.google.maps.LatLng(lat, lng);

            // This is making the Geocode request
            const geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({ latLng: latlng }, (results, status) => {
                if (status !== window.google.maps.GeocoderStatus.OK) {
                    // need to handle failure
                }
                // This is checking to see if the Geoeode Status is OK before proceeding
                if (status == window.google.maps.GeocoderStatus.OK) {
                    let address = "";
                    let gov = "";
                    let city = "";
                    let area = "";

                    if (results[0]) {
                        // formatted address
                        address = results[0].formatted_address;
                        for (let i = 0; i < results[0].address_components.length; i++) {
                            for (
                                let b = 0;
                                b < results[0].address_components[i].types.length;
                                b++
                            ) {
                                if (
                                    results[0].address_components[i].types[b] ==
                                    "administrative_area_level_1"
                                ) {
                                    gov = results[0].address_components[i].short_name;
                                    break;
                                }
                                if (
                                    results[0].address_components[i].types[b] ==
                                    "administrative_area_level_2"
                                ) {
                                    city = results[0].address_components[i].short_name;
                                    break;
                                }
                                if (
                                    results[0].address_components[i].types[b] ==
                                    "administrative_area_level_3"
                                ) {
                                    area = results[0].address_components[i].short_name;
                                    break;
                                }
                            }
                            setMapLocationData(
                                isLocationSelectedFromSearch ? null : address,
                                gov,
                                city,
                                area,
                                lat,
                                lng
                            );
                        }
                    }
                }
            });
        };

        const handleActiveMarker = (marker) => {
            if (marker === activeMarker) {
                return;
            }
            setActiveMarker(marker);
        };

        function SimialrLocationInfo(marker) {
            return (
                <InfoContainer>
                    <InfoHeading>
                        <img
                            src={SimilarMarkerIcon}
                            alt="similar"
                        />
                        Saved location
                    </InfoHeading>
                    <InfoId>{marker?.location?.client_identifier_code}</InfoId>
                    <InfoTitle>
                        {marker?.location?.name_en} - {marker?.location?.name_ar}
                    </InfoTitle>
                    <InfoDetails>{marker?.location?.address}</InfoDetails>
                    <InfoTags>
                        <InfoTag>{marker?.location?.location_type}</InfoTag>
                    </InfoTags>
                </InfoContainer>
            );
        }

        console.log("====> currentPosition", currentPosition)

        return (
            <React.Fragment>
                {isLoaded && <GoogleMap
                    defaultZoom={zoom || 12}
                    zoom={zoom || 12}
                    center={{ lat: currentPosition.lat, lng: currentPosition.lang }}
                    onClick={(e) => onMarkerDragEnd(e)}
                    onLoad={onLoad}
                    mapContainerStyle={{
                        height: 'inherit'
                    }}
                >
                    {isMarkerShown && !multipleMarkers && (
                        <Marker
                            position={{ lat: currentPosition.lat, lng: currentPosition.lang }}
                            defaultDraggable={!readOnly}
                            draggable={!readOnly}
                            onDragEnd={(e) => onMarkerDragEnd(e)}
                            options={{
                                icon: {
                                    url: MapMarker,
                                },
                            }}
                        />
                    )}

                    {multipleMarkers?.length &&
                        multipleMarkers.map((marker) => (
                            <Marker
                                key={marker.id}
                                position={{
                                    lat: marker.attributes.latitude,
                                    lng: marker.attributes.longitude,
                                }}
                                onClick={() => handleActiveMarker(marker.id)}
                            >
                                {activeMarker === marker.id ? (
                                    <InfoWindow onCloseClick={() => setActiveMarker(null)}>
                                        <div>{marker.attributes.name || marker.attributes.name_ar}</div>
                                    </InfoWindow>
                                ) : null}
                            </Marker>
                        ))}
                    {/* Similar locations won't work correctly when react strictmode is inabled */}
                    {similarLocations?.length
                        ? similarLocations.map((marker) => (
                            <Marker
                                key={marker.id}
                                position={{
                                    lat: +marker.location.latitude,
                                    lng: +marker.location.longitude,
                                }}
                                onClick={() => handleActiveMarker(marker.id)}
                                options={{
                                    icon: {
                                        url: SimilarMarkerIcon,
                                    },
                                }}
                            >
                                {activeMarker === marker.id ? (
                                    <InfoWindow onCloseClick={() => setActiveMarker(null)}>
                                        {SimialrLocationInfo(marker)}
                                    </InfoWindow>
                                ) : null}
                            </Marker>
                        ))
                        : null}
                </GoogleMap>}
            </React.Fragment>
        );
    }


export default GoogleMapComponent;
